import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BenefitsVideoComponent } from './benefits-video.component'
import { SharedModule } from '../shared/shared.module'
import { NgxJsonLdModule } from 'ngx-json-ld'

@NgModule({
  declarations: [BenefitsVideoComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgxJsonLdModule
  ],
  exports: [
    BenefitsVideoComponent
  ]
})
export class BenefitsVideoModule { }
